import localforage from 'localforage'

export const localSavedStatesStore = localforage.createInstance({
  storeName: 'pcl-saved-states',
  name: 'pcl',
})
